import { styled } from 'styled-components';

export const AccordionItemContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.gray300};
`;
